export const getCustomIconMixin: { methods: { getIcon: (name: string) => string } } = {
  methods: {
    getIcon(name: string): string {
      return require(`@/assets/img/svg/${name}.svg`);
    }
  }
};
